export const HERO_STAT_KEYS = ['students', 'years', 'campuses', 'programs', 'staff', 'alumni']

export const DEFAULT_HERO_STATS = [
  { key: 'students', value: '2,200+', label_en: 'Students', label_ar: 'الطلاب' },
  { key: 'years', value: '15+', label_en: 'Years', label_ar: 'سنوات' },
  { key: 'campuses', value: '2', label_en: 'Purpose-built campuses in Amman', label_ar: 'حرم مخصص في عمان' },
  { key: 'programs', value: '3', label_en: 'Programs', label_ar: 'برامج' },
  { key: 'staff', value: '300', label_en: 'Staff', label_ar: 'الكادر' },
  { key: 'alumni', value: '1,000', label_en: 'Alumni', label_ar: 'الخريجون' },
]

/** @type {Record<string, { fields?: string[], itemFields?: string[], custom?: string, noteKey?: string }>} */
export const HOMEPAGE_SECTION_CONFIG = {
  hero_stats: {
    fields: [],
    custom: 'heroStats',
  },
  welcome: {
    fields: ['label_en', 'label_ar', 'title_en', 'title_ar', 'content_en', 'content_ar'],
    itemFields: ['title_en', 'title_ar', 'link'],
  },
  about: {
    fields: ['label_en', 'label_ar', 'title_en', 'title_ar', 'content_en', 'content_ar', 'image'],
  },
  excellence: {
    fields: ['label_en', 'label_ar', 'title_en', 'title_ar', 'subtitle_en', 'subtitle_ar'],
    custom: 'excellencePanel',
  },
  programs: {
    fields: ['label_en', 'label_ar', 'title_en', 'title_ar', 'subtitle_en', 'subtitle_ar'],
    itemFields: ['title_en', 'title_ar', 'link', 'image'],
  },
  vision_mission: {
    fields: ['label_en', 'label_ar', 'title_en', 'title_ar'],
  },
  potential: {
    fields: ['label_en', 'label_ar', 'title_en', 'title_ar', 'subtitle_en', 'subtitle_ar'],
    itemFields: ['description_en', 'description_ar', 'subtitle_en', 'subtitle_ar', 'image'],
  },
  find_program: {
    fields: [
      'title_en',
      'title_ar',
      'content_en',
      'content_ar',
      'image',
      'button_text_en',
      'button_text_ar',
      'button_link',
      'button_text_2_en',
      'button_text_2_ar',
      'button_link_2',
    ],
  },
  support_cards: {
    fields: ['label_en', 'label_ar', 'title_en', 'title_ar'],
    itemFields: ['subtitle_en', 'subtitle_ar', 'title_en', 'title_ar', 'description_en', 'description_ar', 'link'],
  },
  mayar_numbers: {
    fields: ['label_en', 'label_ar', 'title_en', 'title_ar', 'subtitle_en', 'subtitle_ar'],
    itemFields: ['title_en', 'title_ar', 'subtitle_en', 'subtitle_ar', 'description_en', 'description_ar', 'link'],
  },
  news: {
    fields: [
      'label_en',
      'label_ar',
      'title_en',
      'title_ar',
      'subtitle_en',
      'subtitle_ar',
      'button_text_en',
      'button_text_ar',
      'button_link',
    ],
    noteKey: 'admin.homepage.notes.newsFeed',
  },
  events: {
    fields: [
      'label_en',
      'label_ar',
      'title_en',
      'title_ar',
      'subtitle_en',
      'subtitle_ar',
      'button_text_en',
      'button_text_ar',
      'button_link',
    ],
    noteKey: 'admin.homepage.notes.eventsFeed',
  },
  continue_journey: {
    fields: ['label_en', 'label_ar', 'title_en', 'title_ar', 'subtitle_en', 'subtitle_ar'],
    itemFields: ['title_en', 'title_ar', 'description_en', 'description_ar', 'link', 'image'],
  },
  facilities: {
    fields: ['label_en', 'label_ar', 'title_en', 'title_ar', 'subtitle_en', 'subtitle_ar'],
    itemFields: ['title_en', 'title_ar', 'link'],
  },
}

/** @type {Record<string, { type: 'text' | 'rich' | 'image' | 'textarea', labelKey: string }>} */
export const HOMEPAGE_FIELD_DEFS = {
  label_en: { type: 'text', labelKey: 'admin.homepage.fields.labelEn' },
  label_ar: { type: 'text', labelKey: 'admin.homepage.fields.labelAr' },
  title_en: { type: 'text', labelKey: 'admin.homepage.fields.titleEn' },
  title_ar: { type: 'text', labelKey: 'admin.homepage.fields.titleAr' },
  subtitle_en: { type: 'textarea', labelKey: 'admin.homepage.fields.subtitleEn' },
  subtitle_ar: { type: 'textarea', labelKey: 'admin.homepage.fields.subtitleAr' },
  content_en: { type: 'rich', labelKey: 'admin.homepage.fields.contentEn' },
  content_ar: { type: 'rich', labelKey: 'admin.homepage.fields.contentAr' },
  description_en: { type: 'textarea', labelKey: 'admin.homepage.fields.descriptionEn' },
  description_ar: { type: 'textarea', labelKey: 'admin.homepage.fields.descriptionAr' },
  image: { type: 'image', labelKey: 'admin.homepage.fields.image' },
  video_url: { type: 'text', labelKey: 'admin.homepage.fields.videoUrl' },
  link: { type: 'text', labelKey: 'admin.homepage.fields.link' },
  button_text_en: { type: 'text', labelKey: 'admin.homepage.fields.buttonEn' },
  button_text_ar: { type: 'text', labelKey: 'admin.homepage.fields.buttonAr' },
  button_link: { type: 'text', labelKey: 'admin.homepage.fields.buttonLink' },
  button_text_2_en: { type: 'text', labelKey: 'admin.homepage.fields.button2En' },
  button_text_2_ar: { type: 'text', labelKey: 'admin.homepage.fields.button2Ar' },
  button_link_2: { type: 'text', labelKey: 'admin.homepage.fields.button2Link' },
}

export function getSectionConfig(key) {
  return HOMEPAGE_SECTION_CONFIG[key] || {
    fields: ['label_en', 'label_ar', 'title_en', 'title_ar', 'subtitle_en', 'subtitle_ar', 'content_en', 'content_ar', 'image'],
    itemFields: ['title_en', 'title_ar', 'subtitle_en', 'subtitle_ar', 'description_en', 'description_ar', 'link', 'image'],
  }
}

export function getSectionDisplayName(section, t, isAr) {
  const keyName = t(`admin.homepage.sections.${section.key}`, { defaultValue: '' })
  if (keyName) return keyName
  if (isAr) return section.title_ar || section.label_ar || section.key
  return section.title_en || section.label_en || section.key.replace(/_/g, ' ')
}

export function getItemDisplayName(item, t, isAr) {
  const keyLabel = item.item_key
    ? t(`admin.homepage.itemKeys.${item.item_key}`, { defaultValue: '' })
    : ''
  if (keyLabel) return keyLabel
  if (isAr) return item.title_ar || item.subtitle_ar || item.item_key || t('admin.homepage.item')
  return item.title_en || item.subtitle_en || item.item_key || t('admin.homepage.item')
}

export function normalizeHeroStats(stats) {
  const byKey = Object.fromEntries((stats || []).map((stat) => [stat.key, stat]))
  return HERO_STAT_KEYS.map((key) => {
    const existing = byKey[key] || {}
    const fallback = DEFAULT_HERO_STATS.find((stat) => stat.key === key) || {}
    return {
      key,
      value: existing.value ?? fallback.value ?? '',
      label_en: existing.label_en ?? fallback.label_en ?? '',
      label_ar: existing.label_ar ?? fallback.label_ar ?? '',
    }
  })
}
